// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__sxSq8","main":"LoginPage_main__ROIAS","inputRow":"LoginPage_inputRow__K7jn8","title":"LoginPage_title__YxT1k","error":"LoginPage_error__mntiQ"};